import React from 'react';
import HesapKayitForm, {
    defaultHesapKayitValues,
    IHesapKayitFormValues
} from 'src/views/logbook/yonetim/shared/HesapKayitForm';

export const KayitEkle = (props: {
    hesapId: number,
    kayit: IHesapKayitFormValues,
    setKayit: (val: IHesapKayitFormValues) => void,
    setKayitEkle: (val: boolean) => void,
    bilgileriGuncelle: (res: any) => void
}) => {
    return (
        <HesapKayitForm
            mode="add"
            kayit={props.kayit}
            setKayit={props.setKayit}
            onClose={() => {
                props.setKayitEkle(false);
                props.setKayit(defaultHesapKayitValues(props.hesapId));
            }}
            onSuccess={(res: any) => {
                props.bilgileriGuncelle(res);
            }}
        />
    );
};

export const KayitDuzenle = (props: {
    kayit: IHesapKayitFormValues,
    setKayit: (val: IHesapKayitFormValues) => void,
    setKayitGuncelle: (val: boolean) => void,
    bilgileriGuncelle: (res: any) => void
}) => {
    return (
        <HesapKayitForm
            mode="edit"
            kayit={props.kayit}
            setKayit={props.setKayit}
            onClose={() => {
                props.setKayit(defaultHesapKayitValues(props.kayit.hesapId));
                props.setKayitGuncelle(false);
            }}
            onSuccess={(res: any) => {
                props.bilgileriGuncelle(res);
            }}
        />
    );
};
